import { ConveyorAdminState, ConveyorAdminActions, ConveyorAdminReducer } from './conveyor-admin.reducer';
/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { ActionReducerMap, Store } from '@ngrx/store';
import { AppActions, AppReducer, AppState } from './app.reducer';
import { AppParamsActions, AppParamsReducer, AppParamsState } from './app-params.reducer';
import { AppUserActions, AppUserState } from './app-user.reducer';
import { MonitorReviewReducer, MonitorReviewState } from './monitor-review.reducer';
import { RulesEngineActions, RulesEngineReducer, RulesEngineState } from './rules-engine.reducer';

import { AppUserReducer } from './app-user.reducer';

export const appReducer: ActionReducerMap<IState> = {
  app: AppReducer,
  appParams: AppParamsReducer,
  appUser: AppUserReducer,
  monitorReview: MonitorReviewReducer,
  rulesEngine: RulesEngineReducer,
  conyevorAdmin: ConveyorAdminReducer
};
export interface IState {
  app?: AppState;
  appParams?: AppParamsState;
  appUser?: AppUserState;
  monitorReview?: MonitorReviewState;
  rulesEngine?: RulesEngineState;
  conyevorAdmin?: ConveyorAdminState;
}
export const initStores = (store: Store<IState>) => {
  store.dispatch({
    type: AppActions.INIT,
  });
  store.dispatch({
    type: AppParamsActions.INIT,
  });
  store.dispatch({
    type: AppUserActions.INIT,
  });
  store.dispatch({
    type: RulesEngineActions.INIT,
  });
  store.dispatch({
    type: RulesEngineActions.INIT_PAGESTATE,
  });
  store.dispatch({
    type: ConveyorAdminActions.INIT,
  });
};
/* PavCon, LLC Proprietary.All rights reserved 2022 */
